module.exports = __webpack_public_path__ + "img/FILTROS.28430244.svg";